<template>
	<div>
		<div class="title">
			<div id="notice">
				<h5>节假日设置使用说明:<br>
					<span>1、必须在设置模板前完成,考勤完成后添加无效</span><br>
					<span>4、查询关键字:单号、申请人。</span><br>
				</h5>
			</div>
		</div>
		<!-- 主+明细 -->
		<pre-base ref="mybase" @base2-event="refresh_father" :pre_data="init_data">
			<!-- <template slot="slot_c_out_fee">
        <pre-select class="short0" ref="out_fee" @selectFunc="selectFunc1" v-bind:searchList="list_fee"
          :selectValue="sel_fee" />
      </template> -->
		</pre-base>

	</div>
</template>

<script>
	// import {
	// 	GetShort
	// } from '@/utils/localstore.js';

	export default {
		components: {
			"pre-base": () => import("../auto/auto_view.vue")
		},
		data() {
			return {
				init_data: '',
				row_id: '',
				item: '',

				// 组件
				show_tan: '0',
				show_item: ''
			};
		},
		mounted: function() {
			var that = this;
			this.$nextTick(function() {
				that.fun_init();
			});
		},
		methods: {
			fun_init: function() {
				// let udata = GetShort('userdata');
				// let rname = '';
				// if (typeof(udata) !== 'undefined' && udata != '') {
				// 	let r = JSON.parse(udata);
				// 	rname = r[0].rname;
				// }
				// console.log('当前角色:' + rname);

				this.init_data = '';
				this.init_data = JSON.stringify({
					"control": "setholidays",
					"title": "节假日设定",
					"isTwo": "0",
					"isTwoDetail": "0",
					"action_flag": "",
					"isFileMain": "1",
					"step": "1",
					"sel_action": 'exp_kq_m_set_holiday',
					"upd_action": 'exp15_kq_m_set_holiday',
					"detail_part": "1",
					"detail_excelup": "1",
					"d_btn_more": "0",
					"d_sel_action": 'exp_kq_d_set_holiday',
					"d_upd_action": '_kq_d_set_holiday',
					"file_action": '',
					"p1": '',
					"p2": '',
					"p3": '',
					"parm_sel": [
						{
							"name": "年份",
							"val": "",
							"key": "year_info",
							"type": "text",
							"class": "long1",
							"sel": "1"
						}
					],
					"parm": [
						{
							"name": "年份",
							"val": "",
							"key": "sheet_no",
							"type": "year",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						},						
						{
							"name": "备注",
							"val": "",
							"key": "note",
							"type": "text",
							"class": "long3",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						}
					],
					"parm_th": [
						{
							"name": "序号"
						}, 
						{
							"name": "年份"
						},
						{
							"name": "节日明细"
						}, 						
						{
							"name": "备注",
							"class": "long2"
						},
						{
							"name": "状态"
						},
						{
							"name": "修改人"
						},
						// {
						// 	"name": "浏览地址"
						// },
						// {
						// 	"name": "存储地址"
						// },
						{
							"name": "更新时间"
						}
					],
					"d_parm": [
						{
							"name": "年份",
							"val": "",
							"key": "sheet_no",
							"type": "none",
							"class": "long1",
							"p": "1",
							"w": "0",
							"r": "1",
							"x": "1"
						},
						{
							"name": "日期",
							"val": "",
							"key": "day_info",
							"type": "date",
							"class": "long1",
							"p": "1",
							"w": "1",
							"r": "1",
							"x": "1"
						},						
						{
							"name": "备注",
							"val": "",
							"key": "note",
							"type": "text",
							"class": "long2",
							"p": "1",
							"w": "0",
							"r": "0",
							"x": "1"
						}
					],
					"d_name": [
						{
							"name": "ID"
						},
						{
							"name": "序号"
						},
						{
							"name": "年份"
						},
						{
							"name": "日期"
						},
						{
							"name": "备注",
							"class": "long2"
						},

						{
							"name": "修改人",
							"class": "short0"
						},
						// {
						// 	"name": "路径1"
						// },
						// {
						// 	"name": "路径2"
						// },
						{
							"name": "更新时间",
							"class": "long2"
						}
					]

				});



				// console.log(this.$refs);
				// this.$refs.mybase.load_data();
				// 解决偶尔第一次没有加载完成时再次 调用一下
				// var that = this;
				// this.$nextTick(function() {
				// 	that.$refs.mybase.load_data();
				// });

			},
			refresh_data: function() {

				var that = this;
				this.$nextTick(function() {
					that.$refs['mybase'].refresh_data('1');
				});
			},
			refresh_father: function(type, val, parm) {
				switch (type) {
					case 'father':
						// 弹出修改明细，修改主窗口信息
						this.refresh_data();
						break;
					default:
						// console.log('子组件刷新父组件传值=' + val);
						this.row_id = val;
						this.item = parm;
						break;
				}
			}



		}
	};
</script>
<style>
</style>
